import React from "react";
import {DatePicker, Table} from "antd";
import {pagination} from "../../controller/Utils";
import {NavLink} from "react-router-dom";
import {CallLogList} from "../../models/marketing/callLog";
import {AddCall} from "./popup/AddCall";
import Button from "../../../node_modules/antd/es/button/button";

const _ = require('lodash');
const moment = require('moment');

const {RangePicker} = DatePicker;

export class CallLog extends React.Component {
  state = {
    data: [],
    pagination: pagination,
    value: [],
    loading: false,
    selectedRowKeys: [],
    params: {},
    addCall: false
  };

  onCheckboxSelectChange = (selectedRowKeys) => {
    this.setState({selectedRowKeys});
  };
  handleTableChange = (pagination, filters, sorter) => {
    const pager = {...this.state.pagination};
    pager.current = pagination.current;
    this.setState({
      pagination: pager,
    });
    let symbol = '';
    if (sorter.order === 'descend')
      symbol = '-';
    this.fetch({
      results: pagination.pageSize,
      page: pagination.current,
      ordering: `${symbol}${sorter.columnKey}`,
      ...filters,
    });
  };
  fetch = (params = {}, reset = false) => {
    if (!reset)
      params = {...this.state.params, ...params};
    this.setState({loading: true, params});
    CallLogList(params)
      .then(response => {
        const pagination = {...this.state.pagination};
        pagination.total = response.data.count;
        this.setState({
          loading: false,
          data: response.data.results,
          pagination,
        });
      });
  };
  onDateRangeChange = (date, dateString) => {
    this.fetch({
      date_fields: 'created',
      start_date: dateString[0],
      end_date: dateString[1]
    })
  };


  columns = [
    {
      title: 'Created Date',
      dataIndex: 'created',
      key: 'created',
      sorter: true,
      render: created => moment(created).format('YYYY-MM-DD')
    }, {
      title: 'Name',
      render: item => `${item.first_name} ${item.last_name}`
    }, {
      title: 'Company Name',
      dataIndex: 'company_name',
    }, {
      title: "Email",
      dataIndex: 'email',
    }, {
      title: "Hear About Us",
      dataIndex: 'hear_about_us.label',
    },{
      title: "Lead Level",
      dataIndex: 'lead_level.label',
    }, {
      title: "Phone",
      dataIndex: 'phones',
      render: phones => phones.map(item => item.phone).join(', ')
    }, {
      title: "Address",
      dataIndex: 'address',
      render: address => address.map(item => item.address).join(', ')
    },
  ];


  setAddCall(addCall) {
    this.setState({ addCall})
  }

  componentDidMount() {
    if (this.props.onRef)
      this.props.onRef(this);
    else
      this.fetch();
  }

  componentWillUnmount() {
    if (this.props.onRef)
      this.props.onRef(null)
  }

  render() {
    const {pagination, data, loading, selectedRowKeys, addCall} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-sm-3 col-12">
                <h3 className="main-heading">AB Marketing</h3>
              </div>
              <div className="col-sm-9 col-12">
                <ul className="nav justify-content-end top-submenu">
                  <li className="nav-item">
                    <NavLink activeClassName="active" to="/dashboard/marketing/call-log/">Call Log</NavLink>
                  </li>
                </ul>
              </div>
            </div>
            <div className="row clearfix edit-header">
              <div className="col-lg-3 col-sm-4 col-12">
                <div id="date_range_wrapper">
                  <RangePicker onChange={this.onDateRangeChange}/>
                </div>
              </div>
              <div className="col-lg-2 col-sm-2 col-12 pull-xs-left">
                <button className="btn submit-btn xs-hide" type="button" onClick={() => this.setAddCall(true)}>Create Call Log</button>
                <button className="btn submit-btn xs-show" type="button" onClick={() => this.setAddCall(true)}><i className="fa fa-plus"></i> </button>
              </div>
              <div className="col-lg-2 col-sm-2 col-12 padding-0 pull-xs-left">
                <button onClick={() => this.fetch({}, true)} className="refresh-btn" id="call-log-refresh"><i className="fa fa-repeat"/> </button>
              </div>
              <div className="col-sm-3 col-12 edit-div">
                <span>{pagination.total} Records</span>
              </div>
            </div>
            <div className="row clearfix">
              <div className="col-12">
                <div className="listing-table">
                  <Table
                    className="responsive-table table table-hover js-basic-example dataTable table-custom table-striped m-b-0 c_list"
                    pagination={pagination} rowKey={row => row.id} columns={this.columns}
                    dataSource={data} loading={loading} onChange={this.handleTableChange}
                    locale={{emptyText: 'No Call Log Available'}}/>
                </div>
              </div>
              <AddCall visible={addCall} fetch={() => this.fetch()} onClose={() => this.setAddCall(false)}/>
            </div>
          </div>
        </div>
      </div>)
  }
}



// WEBPACK FOOTER //
// ./src/pages/ab-marketing/CallLog.jsx